export class Attribute {
    public attr: string;
    public value: string;
    
    constructor(data) {
        Object.assign(this, data);
    }
}
